import { LoggerService } from "@/modules/common/logger/loggerService"
import type { ApiClient } from "@/modules/core/api/client/apiClient"
import type { CoachCategoriesApiGateway } from "@modules/coachCategories/gateway/coachCategoriesApiGateway"
import {
  CategoryProgramDtoSchema,
  CategorySlotDefaultValueDtoSchema,
  type CategoryProgramBodyInputDto,
  type CategoryProgramDto,
  type CategorySlotDefaultInputDto,
  type CategorySlotDefaultValueDto,
} from "@modules/coachCategories/gateway/coachCategoriesDto"

export class CoachCategoriesApi implements CoachCategoriesApiGateway {
  private baseUrl = "/pro/category-programs"

  constructor(private api: ApiClient) {}

  async getCoachCategories(): Promise<CategoryProgramDto[]> {
    const result = await this.api.get<CategoryProgramDto[]>(this.baseUrl)
    return result.data.map((dto) => LoggerService.parseApiDto(CategoryProgramDtoSchema, dto))
  }

  async getCoachCategory(id: string): Promise<CategoryProgramDto> {
    const result = await this.api.get<CategoryProgramDto>(`${this.baseUrl}/${id}`)
    return LoggerService.parseApiDto(CategoryProgramDtoSchema, result.data)
  }

  async createCoachCategory(input: CategoryProgramBodyInputDto): Promise<CategoryProgramDto> {
    const result = await this.api.post<CategoryProgramDto>(this.baseUrl, input)
    return LoggerService.parseApiDto(CategoryProgramDtoSchema, result.data)
  }

  async updateCoachCategory(id: string, input: CategoryProgramBodyInputDto): Promise<CategoryProgramDto> {
    const result = await this.api.put<CategoryProgramDto>(`${this.baseUrl}/${id}`, input)
    return LoggerService.parseApiDto(CategoryProgramDtoSchema, result.data)
  }

  async getCoachCategorySlotDefaults(id: string): Promise<CategorySlotDefaultValueDto> {
    const result = await this.api.get<CategorySlotDefaultValueDto>(`${this.baseUrl}/${id}/slot-defaults`)
    return LoggerService.parseApiDto(CategorySlotDefaultValueDtoSchema, result.data)
  }

  async updateCoachCategorySlotDefaults(
    id: string,
    input: CategorySlotDefaultInputDto,
  ): Promise<CategorySlotDefaultValueDto> {
    const result = await this.api.put<CategorySlotDefaultValueDto>(`${this.baseUrl}/${id}/slot-defaults`, input)
    return LoggerService.parseApiDto(CategorySlotDefaultValueDtoSchema, result.data)
  }

  async deleteCoachCategory(id: string): Promise<void> {
    await this.api.delete(`${this.baseUrl}/${id}`)
  }
}
